export const SCHEMA_TEXT = {
  ORG_NAME: 'Atlas Creative'
} as const

export const SCHEMA_SAME_AS = [
  'https://x.com/AtlasCreativeFN',
  'https://www.tiktok.com/@atlascreativefn',
  'https://www.linkedin.com/company/atlascreative/',
  'https://discord.com/invite/atlas-creative-516619453887414284'
] as const

export function schemaIds(appUrl: string) {
  const base = appUrl.replace(/\/$/, '')
  return {
    ORG: `${base}/#organization`,
    WEBSITE: `${base}/#website`
  }
}
